import React, { useState } from 'react';
import { Box, Button, Typography, Alert, TextField, Stack } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const DebugAuth: React.FC = () => {
  const { user, loading, login, register } = useAuth();
  const [testEmail, setTestEmail] = useState('test@example.com');
  const [testPassword, setTestPassword] = useState('password123');
  const [testName, setTestName] = useState('Test User');
  const [message, setMessage] = useState('');
  
  // Only show debug tool to authorized users
  const authorizedEmails = [
    'amarildo121@gmail.com', // Amar - main admin
    'test@example.com'       // Test user
  ];
  
  // Don't render if user is not authorized
  if (!user || !authorizedEmails.includes(user.email)) {
    return null;
  }

  const handleTestLogin = async () => {
    try {
      setMessage('Attempting login...');
      await login(testEmail, testPassword);
      setMessage('Login successful!');
    } catch (error: any) {
      setMessage(`Login failed: ${error.message}`);
    }
  };

  const handleTestRegister = async () => {
    try {
      setMessage('Attempting registration...');
      await register(testName, testEmail, testPassword);
      setMessage('Registration successful!');
    } catch (error: any) {
      setMessage(`Registration failed: ${error.message}`);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500, margin: 'auto', border: '1px solid #ccc', borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        🔧 Auth Debug Tool
      </Typography>
      
      <Stack spacing={2}>
        <Typography variant="body2">
          <strong>Loading:</strong> {loading ? '🔄 YES' : '✅ NO'}
        </Typography>
        
        <Typography variant="body2">
          <strong>User:</strong> {user ? `✅ ${user.name} (${user.email})` : '❌ NOT LOGGED IN'}
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Test Authentication:
        </Typography>

        <TextField
          label="Name"
          value={testName}
          onChange={(e) => setTestName(e.target.value)}
          size="small"
          fullWidth
        />

        <TextField
          label="Email"
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          size="small"
          fullWidth
        />

        <TextField
          label="Password"
          type="password"
          value={testPassword}
          onChange={(e) => setTestPassword(e.target.value)}
          size="small"
          fullWidth
        />

        <Stack direction="row" spacing={2}>
          <Button 
            variant="contained" 
            color="primary"
            onClick={handleTestLogin}
            disabled={loading}
            fullWidth
          >
            Test Login
          </Button>

          <Button 
            variant="outlined" 
            color="secondary"
            onClick={handleTestRegister}
            disabled={loading}
            fullWidth
          >
            Test Register
          </Button>
        </Stack>

        {message && (
          <Alert 
            severity={
              message.includes('successful') ? 'success' : 
              message.includes('Attempting') ? 'info' : 'error'
            }
          >
            {message}
          </Alert>
        )}

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
          This debug tool will be removed in production. Use it to test authentication without going through the full UI.
        </Typography>
      </Stack>
    </Box>
  );
};

export default DebugAuth; 